<template>
  <div class="cargoWarehousing">
    <van-form label-width="80px">
      <div class="title" v-if="pageType == 'edit'">
        {{ $t.cargoWarehousing.editTitle }}
      </div>
      <div class="title" v-if="pageType == 'view'">
        {{ $t.cargoWarehousing.viewTitle }}
      </div>
      <div class="title" v-if="pageType == 'outbound'">
        {{ $t.cargoWarehousing.applyOutbound }}
      </div>
      <div class="title" v-if="pageType == 'outboundEdit'">
        {{ $t.cargoWarehousing.editOutbound }}
      </div>

      <template v-if="isEdit">
        <div class="cargoWarehousing-radio" v-if="pageType == 'outbound'">
          <div class="radio-label">{{ $t.cargoWarehousing.outboundTypeLabel }}</div>
          <van-radio-group
            v-model="form.OutboundType"
            direction="horizontal"
            @change="handleRadioChange"
          >
            <van-radio :name="1">{{ $t.cargoWarehousing.outboundType1 }}</van-radio>
            <van-radio :name="2">{{ $t.cargoWarehousing.outboundType2 }}</van-radio>
          </van-radio-group>
        </div>

        <van-field
          v-model="form.EMIdStr"
          :label="$t.cargoWarehousing.deliverer"
          @click="pickerShow('showDelivererPicker')"
          :placeholder="$t.meta.select"
          clickable
          readonly
          required
          v-if="form.OutboundType == 1"
        />

        <van-field
          v-model="form.WHIdStr"
          :label="$t.cargoWarehousing.warehouse"
          @click="pickerShow('showWarehousePicker')"
          :placeholder="$t.meta.select"
          clickable
          readonly
          required
          v-if="form.OutboundType == 2"
        />

        <van-field
          v-model="form.DriverIdStr"
          :label="$t.cargoWarehousing.driver"
          @click="pickerShow('showDriverPicker')"
          :placeholder="$t.meta.select"
          clickable
          readonly
          required
          v-if="form.OutboundType == 2"
        />

        <van-field
          v-model="form.VehicleIdStr"
          :label="$t.cargoWarehousing.vehicle"
          @click="pickerShow('showVehiclePicker')"
          :placeholder="$t.meta.select"
          clickable
          readonly
          required
          v-if="form.OutboundType == 2"
        />

        <van-field
          v-model="form.MawbNumber"
          :label="$t.cargoWarehousing.mawbNumber"
          :placeholder="$t.meta.input"
          required
          v-if="form.OutboundType == 2"
        />
      </template>
      <template v-if="pageType == 'view' || (pageType == 'edit' && !isEdit)">
        <div class="custom-field">
          <div class="custom-field-label">{{ $t.cargoWarehousing.warehouse }}</div>
          <div class="custom-field-value">
            <span>{{ form.WHIdStr }}</span>
          </div>
        </div>

        <div class="custom-field">
          <div class="custom-field-label">{{ $t.cargoWarehousing.driver }}</div>
          <div class="custom-field-value">
            <span>{{ form.DriverIdStr }}</span>
          </div>
        </div>

        <div class="custom-field">
          <div class="custom-field-label">{{ $t.cargoWarehousing.vehicle }}</div>
          <div class="custom-field-value">
            <span>{{ form.VehicleIdStr }}</span>
          </div>
        </div>

        <div class="custom-field">
          <div class="custom-field-label">{{ $t.cargoWarehousing.mawbNumber }}</div>
          <div class="custom-field-value">
            <span>{{ form.MawbNumber }}</span>
          </div>
        </div>
      </template>
    </van-form>

    <div
      class="list-container"
      :style="{
        'margin-top': isEdit ? '0px' : '10px',
      }"
      v-for="(item, index) in tableData"
      :key="index"
    >
      <div class="checkBox" v-if="isEdit">
        <checkbox
          v-model="item.IsChecked"
          :disabled="item.disabled"
          @input="handleCheckBox"
        ></checkbox>
      </div>
      <div class="container">
        <template v-if="pageType == 'outbound' || pageType == 'outboundEdit'">
          <div class="list-item">
            {{ $t.cargoWarehousing.mainWbNumber }}：{{ item.PWB_Number }}
          </div>
          <div class="list-item">
            {{ $t.cargoWarehousing.sideWbNumber }}：{{ item.WB_Number }}
          </div>
          <template v-if="pageType == 'outbound'">
            <div class="list-item">
              {{ $t.cargoWarehousing.goodsName }}：{{ item.GoodsDescribe }}
            </div>
            <div class="list-item">
              {{ $t.cargoWarehousing.orderPiece }}：{{ item.AllBoxNumber }}
            </div>
            <div class="list-item">
              {{ $t.cargoWarehousing.weight }}：{{ item.AllWeight }}
            </div>
          </template>
          <template v-if="pageType == 'outboundEdit'">
            <div class="list-item">
              {{ $t.cargoWarehousing.totalNumber }}：{{ item.AllBoxNumber }}
            </div>
            <div class="list-item">
              {{ $t.cargoWarehousing.totalWeight }}：{{ item.AllWeight }}
            </div>
            <div class="list-item">
              {{ $t.cargoWarehousing.totalValue }}：{{ item.AllVolume }}
            </div>
            <div class="list-item">
              {{ $t.cargoWarehousing.deliverer }}：{{ item.FullName }}
            </div>
          </template>
          <div class="list-item">
            {{ $t.cargoWarehousing.isCodorder }}：
            <span v-if="item.is_codorder">{{ $t.meta.yes }}</span>
            <span v-else>{{ $t.meta.no }}</span>
          </div>
          <div class="list-item">
            {{ $t.cargoWarehousing.consignee }}：{{ item.ConsigneeName }}
          </div>
          <div class="list-item">
            {{ $t.cargoWarehousing.consigneePhone }}：{{ item.ConsigneePhone }}
          </div>
          <div class="list-item">
            {{ $t.cargoWarehousing.consigneeAddress }}：{{ item.ConsigneeAddress }}
          </div>
          <div class="list-item" v-if="pageType == 'outboundEdit'">
            {{ $t.cargoWarehousing.outBoundState }}：
            <span v-if="item.OutboundState == 0">{{ $t.cargoWarehousing.obState1 }}</span>
            <span v-if="item.OutboundState == 1">{{ $t.cargoWarehousing.obState2 }}</span>
            <span v-if="item.OutboundState == 2">{{ $t.cargoWarehousing.obState3 }}</span>
          </div>
        </template>
        <template v-else>
          <div class="list-item">
            {{ $t.cargoWarehousing.mainWbNumber }}：{{ item.PWB_Number }}
          </div>
          <div class="list-item">
            {{ $t.cargoWarehousing.sideWbNumber }}：{{ item.WB_Number }}
          </div>
          <div class="list-item">
            {{ $t.cargoWarehousing.totalNumber }}：{{ item.AllBoxNumber }}
          </div>
          <div class="list-item">
            {{ $t.cargoWarehousing.totalWeight }}：{{ item.AllWeight }}
          </div>
          <div class="list-item">
            {{ $t.cargoWarehousing.totalValue }}：{{ item.AllVolume }}
          </div>
        </template>
      </div>
    </div>

    <van-popup v-model="showDelivererPicker" round position="bottom">
      <van-picker
        :title="$t.cargoWarehousing.deliverer"
        show-toolbar
        :columns="delivererOptions"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="delivererConfirm($event)"
        @cancel="showDelivererPicker = false"
      />
    </van-popup>

    <van-popup v-model="showWarehousePicker" round position="bottom">
      <van-picker
        :title="$t.cargoWarehousing.warehouse"
        show-toolbar
        :columns="warehouseList"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="warehouseConfirm($event)"
        @cancel="showWarehousePicker = false"
      />
    </van-popup>

    <van-popup v-model="showDriverPicker" round position="bottom">
      <van-picker
        :title="$t.cargoWarehousing.driver"
        show-toolbar
        :columns="driverOptions"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="driverConfirm($event)"
        @cancel="showDriverPicker = false"
      />
    </van-popup>

    <van-popup v-model="showVehiclePicker" round position="bottom">
      <van-picker
        :title="$t.cargoWarehousing.vehicle"
        show-toolbar
        :columns="vehiclesList"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="vehicleConfirm($event)"
        @cancel="showVehiclePicker = false"
      />
    </van-popup>

    <div class="tool-bar" v-if="isEdit">
      <van-button type="info" block @click="onSubmit">{{ $t.meta.confirm }}</van-button>
    </div>
  </div>
</template>

<script>
import {
  List,
  Row,
  Col,
  Button,
  Form,
  Field,
  Popup,
  Picker,
  Radio,
  RadioGroup,
} from "vant";

import Vue from "vue";
import Checkbox from "@components/checkbox/Checkbox.vue";

Vue.use(List)
  .use(Row)
  .use(Col)
  .use(Button)
  .use(Form)
  .use(Field)
  .use(Popup)
  .use(Picker)
  .use(Radio)
  .use(RadioGroup);

export default {
  name: "cargoWarehousing",
  components: {
    Checkbox,
  },
  data() {
    return {
      pageType: "outbound", //edit,view,outbound,outboundEdit
      ECWId: "",
      outboundBatch: "",
      isEdit: true,
      tableData: [],
      checkedList: [],
      delivererOptions: [], //派送员
      driverOptions: [], //司机
      warehouseList: [], //仓库
      vehiclesList: [], //车辆
      form: {
        OutboundType: 1,
        //出仓
        EMId: "",
        EMIdStr: "",
        //转仓
        WHId: "",
        WHIdStr: "",
        DriverId: "",
        DriverIdStr: "",
        VehicleId: "",
        VehicleIdStr: "",
        MawbNumber: "",
      },
      showDelivererPicker: false,
      showWarehousePicker: false,
      showDriverPicker: false,
      showVehiclePicker: false,
    };
  },
  mounted() {
    const { Type, ECWId, OutboundBatch } = this.$route.query;
    this.pageType = Type;
    if (this.pageType == "edit" || this.pageType == "view") {
      this.ECWId = ECWId;
      this.form.OutboundType = 2;
      this.getOptions(1).then((success) => {
        if (success) {
          this.getExpressCargoWarehousingInfoByECWId();
        }
      });
    }
    if (this.pageType == "outboundEdit") {
      this.outboundBatch = OutboundBatch;
      this.getOptions(2).then((success) => {
        if (success) {
          this.getOutboundDetailByOutboundBatch();
        }
      });
    }
    if (this.pageType == "outbound") {
      var data = JSON.parse(localStorage.getItem("cargoWarehousing"));
      this.tableData = data;
      this.handleCheckBox();
      this.getOptions(2);
    }
  },
  methods: {
    handleRadioChange() {
      this.form.EMId = "";
      this.form.EMIdStr = "";
      this.form.WHId = "";
      this.form.WHIdStr = "";
      this.form.DriverId = "";
      this.form.DriverIdStr = "";
      this.form.VehicleId = "";
      this.form.VehicleIdStr = "";
      this.form.MawbNumber = "";
      if (this.form.OutboundType == 2) {
        this.getOptions(3);
      } else {
        this.getOptions(2);
      }
    },
    handleCheckBox() {
      if (this.pageType == "outboundEdit") {
      }
      if (this.pageType == "outbound") {
        var list = [];
        for (var item of this.tableData) {
          list.push({
            ECWBId: item.ECWBId,
          });
        }
        this.checkedList = list;
      }
    },
    pickerShow(pickerName) {
      this[pickerName] = true;
    },
    delivererConfirm(e) {
      this.form.EMIdStr = e.text;
      this.form.EMId = e.value;
      this.showDelivererPicker = false;
    },
    warehouseConfirm(e) {
      this.form.WHIdStr = e.text;
      this.form.WHId = e.value;
      this.showWarehousePicker = false;
    },
    driverConfirm(e) {
      this.form.DriverIdStr = e.text;
      this.form.DriverId = e.value;
      this.showDriverPicker = false;
    },
    vehicleConfirm(e) {
      this.form.VehicleIdStr = e.text;
      this.form.VehicleId = e.value;
      this.showVehiclePicker = false;
    },
    getExpressCargoWarehousingInfoByECWId() {
      return new Promise((resolve, reject) => {
        this.$commonMethod.showLoading();
        var param = {
          ECWId: this.ECWId,
        };
        this.$api.storage
          .getExpressCargoWarehousingInfoByECWId(param)
          .then((res) => {
            var data = res.data;
            this.isEdit = data.DriverDeliveryState == 0 ? true : false;
            this.form.WHId = data.WHId.toString();
            this.form.WHIdStr = data.WarehouseName;
            this.form.DriverId = data.EMId;
            this.form.DriverIdStr = data.FullName;
            this.form.VehicleId = data.VehicleId;
            this.form.VehicleIdStr = data.LicensePlate;
            this.form.MawbNumber = data.MawbNumber;
            var waybillList = data.WaybillList;
            for (var index in waybillList) {
              waybillList[index].IsChecked = true;
            }
            this.tableData = this.$commonMethod.deepClone(waybillList);
            this.$forceUpdate();
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
            reject();
          });
      });
    },
    getOutboundDetailByOutboundBatch() {
      return new Promise((resolve, reject) => {
        this.$commonMethod.showLoading();
        var param = {
          OutboundBatch: this.outboundBatch,
        };
        this.$api.storage
          .getOutboundDetailByOutboundBatch(param)
          .then((res) => {
            var data = res.data;
            this.isEdit = data.IsEdit ? true : false;
            var waybillList = data.WaybillList;
            for (var index in waybillList) {
              waybillList[index].IsChecked = true;
              if (waybillList[index].OutboundState != 0) {
                waybillList[index].disabled = true;
              }
            }
            this.tableData = this.$commonMethod.deepClone(waybillList);
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
            reject();
          });
      });
    },
    getOptions(role) {
      return new Promise((resolve) => {
        this.$commonMethod.showLoading();
        Promise.all([
          this.getWarehouseManagementList(),
          this.getExpressEmployeeList(role),
          this.getVehiclesList(),
        ])
          .then((success) => {
            if (success) {
              resolve(true);
            }
            this.$commonMethod.hideLoading();
          })
          .catch(() => {
            this.$commonMethod.hideLoading();
          });
      });
    },
    getWarehouseManagementList() {
      this.$commonMethod.showLoading();
      var param = {
        WarehouseState: 1,
        PageIndex: 1,
        PageSize: 999,
      };
      this.$api.storage
        .getWarehouseManagementList(param)
        .then((res) => {
          var result = [];
          res.data.Data.forEach((item) => {
            let data = {
              text: item.WarehouseName,
              value: item.WHId,
            };
            result.push(data);
          });
          this.warehouseList = result;
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    getExpressEmployeeList(role) {
      return new Promise((resolve) => {
        var param = {
          EmployeeRole: role,
          IsLocked: 0,
        };
        this.$api.storage
          .getExpressEmployeeListByPage(param)
          .then((res) => {
            var result = [];
            res.data.Data.forEach((item) => {
              let data = {
                text: item.FullName + " , " + item.PhoneNumber,
                value: item.EMId,
              };
              result.push(data);
            });
            if (this.form.OutboundType == 2) {
              this.driverOptions = result;
            } else {
              this.delivererOptions = result;
            }
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    getVehiclesList() {
      return new Promise((resolve) => {
        var param = {
          VehicleStatus: 1,
        };
        this.$api.storage
          .getVehiclesListByPage(param)
          .then((res) => {
            var result = [];
            res.data.Data.forEach((item) => {
              let data = {
                text: item.LicensePlate + " , " + item.Brand,
                value: item.VehicleId,
              };
              result.push(data);
            });
            this.vehiclesList = result;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    onSubmit() {
      if (this.pageType == "outboundEdit") {
        var request1 = (param) => {
          this.$commonMethod.showLoading();
          this.$api.storage
            .editOutboundBatch(param)
            .then((res) => {
              this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
                titleMsg: res.message,
                type: "success",
              });
              this.$commonEnv.commonAction(this.$commonEnv.actionType.pop);
              this.$commonMethod.hideLoading();
            })
            .catch((error) => {
              this.$commonMethod.hideLoading();
              this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
                msg: error.message,
              });
            });
        };
        var param = {
          EMId: this.form.EMId,
          OutboundBatch: this.outboundBatch,
          EditExpressCargoWaybillList: this.tableData,
        };
        var uncheckCounts = 0;
        for (var item of this.tableData) {
          if (!item.IsChecked && !item.disabled) {
            uncheckCounts = uncheckCounts + 1;
          }
        }
        if (uncheckCounts) {
          this.$commonMethod.customAlert(
            {
              message: this.$t.cargoWarehousing.submitNotice1,
              cancelButtonText: this.$t.alert.cancelButtonText,
              confirmButtonText: this.$t.alert.confirmButtonText,
            },
            () => {
              request1(param);
            },
            () => {}
          );
        } else {
          request1(param);
        }
      }
      if (this.pageType == "edit") {
        var request2 = (param) => {
          this.$commonMethod.showLoading();
          this.$api.storage
            .editExpressCargoWarehousing(param)
            .then((res) => {
              this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
                titleMsg: res.message,
                type: "success",
              });
              this.$commonEnv.commonAction(this.$commonEnv.actionType.pop);
              this.$commonMethod.hideLoading();
            })
            .catch((error) => {
              this.$commonMethod.hideLoading();
              this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
                msg: error.message,
              });
            });
        };
        var param = {
          ECWId: this.ECWId,
          WHId: this.form.WHId,
          DriverId: this.form.DriverId,
          VehicleId: this.form.VehicleId,
          MawbNumber: this.form.MawbNumber,
          EditExpressCargoWaybillList: this.tableData,
        };
        var uncheckCounts = 0;
        for (var item of this.tableData) {
          if (!item.IsChecked && !item.disabled) {
            uncheckCounts = uncheckCounts + 1;
          }
        }
        if (uncheckCounts) {
          this.$commonMethod.customAlert(
            {
              message: this.$t.cargoWarehousing.submitNotice2,
              cancelButtonText: this.$t.alert.cancelButtonText,
              confirmButtonText: this.$t.alert.confirmButtonText,
            },
            () => {
              request2(param);
            },
            () => {}
          );
        } else {
          request2(param);
        }
      }
      if (this.pageType == "outbound") {
        this.$commonMethod.showLoading();
        var param = this.form;
        var ECWBIdList = [];
        for (var item of this.checkedList) {
          ECWBIdList.push(item.ECWBId);
        }
        param.ECWBIdList = ECWBIdList;
        this.$api.storage
          .applyOutbound(param)
          .then((res) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
              titleMsg: res.message,
              type: "success",
            });
            this.$commonEnv.commonAction(this.$commonEnv.actionType.pop);
            this.$commonMethod.hideLoading();
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";
.cargoWarehousing {
  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }
  .van-cell::after {
    border: none !important;
  }
  .cargoWarehousing-radio {
    padding: 20px;
    border-bottom: 1px solid #ebedf0;
    .radio-label {
      color: #646566;
      margin-bottom: 20px;
      font-size: 14px;
    }
    .van-radio {
      margin-right: 20px;
      font-size: 14px;
    }
  }
  .custom-field {
    font-size: 14px;
    padding: 12px 16px;
    border-bottom: 1px solid #ebedf0;
    .custom-field-label {
      width: 80px;
      display: inline-block;
      margin-right: 12px;
      font-size: 14px;
      color: #646566;
    }
    .custom-field-value {
      width: 50%;
      display: inline-block;
      font-size: 14px;
      color: #323233;
    }
  }
  .list-container {
    font-size: 12px;
    color: #333;
    .checkBox {
      vertical-align: middle;
      display: inline-block;
      margin: 15px;
    }
    .container {
      box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.2);
      padding: 10px;
      .list-item {
        margin-bottom: 10px;
      }
      .list-item:last-child {
        margin-bottom: 0px;
      }
    }
  }
  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);
    .van-button {
      border-radius: 0px;
    }
  }
}
</style>
